export default __webpack_public_path__ + "static/media/lightrain.120c791c.svg";